import { render, staticRenderFns } from "./ModattaSettingsSecurity.vue?vue&type=template&id=2e94f5c2"
import script from "./ModattaSettingsSecurity.vue?vue&type=script&lang=js"
export * from "./ModattaSettingsSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports